import { createAction } from 'redux-actions';

import dynaForms from '@elab/core/utils/dynaForms';

import getTypes from './types';

export const getActions = storeName => ({
    ...dynaForms.getActions(storeName),
    setFakeValidation: createAction(getTypes(storeName).SET_FAKE_VALIDATION),
    setEditing: createAction(getTypes(storeName).SET_EDITING),
    openFormInDialog: createAction(getTypes(storeName).OPEN_FORM_IN_DIALOG),
    reset: createAction(getTypes(storeName).RESET),
    setAddressType: createAction(getTypes(storeName).SET_ADDRESS_TYPE),
    setRadioView: createAction(getTypes(storeName).SET_RADIO_VIEW),
    setSubmitEditUrl: createAction(getTypes(storeName).SET_SUBMIT_EDIT_URL),
    setSubmitAddUrl: createAction(getTypes(storeName).SET_SUBMIT_ADD_URL),
    setSubmitEditMethod: createAction(getTypes(storeName).SET_SUBMIT_EDIT_METHOD),
    setSelectForPaymentAfterEditing: createAction(
        getTypes(storeName).SET_SELECT_FOR_PAYMENT_AFTER_EDITING,
    ),
});
